import '../style.scss';

import { useNavigate } from '@hulu/react-router-dom';
import { AccountMenu, ProfileMenu } from '@hulu/react-style-components';
import React, { useCallback, useEffect, useRef } from 'react';

import bem from '../../../utils/bem';
import type { Props } from '../UserNav/UserNav';

const [block] = bem('account-menu');

/**
 * User menu shown when authentication is turned off (REACT_APP_AUTH_FEATURE_ENABLED=false):
 * a static local user, with no session lookup and no redirect.
 */
export const AuthOffUserNav: React.FC<Props> = ({ isOpen, setIsOpen, setWidthOfModal }) => {
  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (setWidthOfModal) {
      setWidthOfModal(ref.current ? ref?.current?.offsetWidth : 0);
    }
  }, [setWidthOfModal, isOpen]);

  const logout = useCallback(() => {
    navigate('/logout');
  }, [navigate]);

  return (
    <AccountMenu
      className={block()}
      firstName="Local"
      lastName="User"
      isOpen={isOpen}
      onClick={(): void => setIsOpen(!isOpen)}
      ref={ref}
    >
      <ProfileMenu isOpen={isOpen}>
        <button className="logout-btn" key="logout" onClick={logout} type="button">
          Logout
        </button>
      </ProfileMenu>
    </AccountMenu>
  );
};
